import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let configPromise = null;

export function getSocialConfig() {
  if (!configPromise) {
    configPromise = axios.get(`${API}/social/config`).then((r) => r.data)
      .catch(() => ({ links: {}, meta_pixel_id: '', feed_enabled: false }));
  }
  return configPromise;
}

export function getInstagramFeed() {
  return axios.get(`${API}/social/instagram-feed`).then((r) => r.data).catch(() => ({ items: [] }));
}

export function initPixel(id) {
  if (!id || window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', id);
  window.fbq('track', 'PageView');
}
